import { VitalsConfig, VitalsSelectedItemsType } from '../../../api/pushGenie';
import { VitalsEntity } from '../../../store/types/prescription';

export const OLD_HARDCODED_VITALS_TO_NEW_MAPPING: {
    [k: string]: { vId: string; unitCodeId: string };
} = {
    'ov-131': { vId: 'v-1903335397', unitCodeId: 'vu-2305998272' },
    'ov-132': { vId: 'v-5515219396', unitCodeId: 'vu-2306951588' },
    'ov-133': { vId: 'v-1116138711', unitCodeId: 'vu-3016364667' },
    'ov-134': { vId: 'v-1116794113', unitCodeId: 'vu-3016364667' },
    'ov-135': { vId: 'v-4698691230', unitCodeId: 'vu-2329086300' },
    'ov-136': { vId: 'v-4084957654', unitCodeId: 'vu-3037642082' },
    'ov-137': { vId: 'v-5175552214', unitCodeId: 'vu-5202556362' },
};

export const OLD_HARDCODED_VITALS_TO_NEW_MAPPING_V_TO_LB: { [k: string]: string } = {
    'v-5515219396': 'lb-7991006736',
    'v-1903335397': 'lb-7561569471',
    'v-9497159785': 'lb-5305097546',
    'v-4084957654': 'lb-1201285132',
    'v-5175552214': 'lb-1771358750',
    'v-9739328347': 'lb-8415690160',
    'v-4698691230': 'lb-199711567',
    'v-1116138711': 'lb-9242267093',
    'v-1116794113': 'lb-8296133834',
};

export interface MDBVitalsType {
    id: string;
    name: string;
    dis_name: string;
    units_with_ranges?: UnitsWithRangesEntity[] | null;
}
export interface UnitsWithRangesEntity {
    dis_unit: string;
    code: string;
    code_id: string;
    system: string;
    safe: Safe;
    // valid: Valid;
}
export interface Safe {
    low?: string;
    high?: string;
    type: 'Numeric' | 'string';
    is_decimal_allowed?: boolean;
    normal_value?: string;
}
// export interface Valid {}

// hardcoded from mdb server api
// mdb/v1/vitals
export const SERVER_VITALS = [
    {
        id: 'lb-1201285132',
        snomed_id: '78564009',
        name: 'Pulse rate',
        dis_name: 'Pulse',
        units_with_ranges: [
            {
                dis_unit: '/min',
                code: '286549009',
                code_id: 'vu-3037642082',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '60',
                    high: '100',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-1771358750',
        name: 'Peripheral oxygen saturation',
        snomed_id: '431314004',
        dis_name: 'SpO2',
        units_with_ranges: [
            {
                dis_unit: '%',
                code: '415067009',
                code_id: 'vu-5202556362',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '95',
                    high: '100',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'v-1365277675',
        snomed_id: '75367002',
        name: 'Blood pressure',
        dis_name: 'Blood pressure',
        units_with_ranges: [
            {
                dis_unit: 'mmHg',
                code: '259018001',
                code_id: 'vu-3016364667',
                system: 'http://snomed.info/sct',
                safe: { type: 'string', is_decimal_allowed: true, normal_value: '120/80' },
            },
        ],
    },
    {
        id: 'lb-8415690160',
        snomed_id: '86290005',
        name: 'Respiratory rate',
        dis_name: 'Respiratory rate',
        units_with_ranges: [
            {
                dis_unit: '/min',
                code: '286549009',
                code_id: 'vu-3037642082',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '12',
                    high: '16',
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    {
        id: 'lb-199711567',
        snomed_id: '386725007',
        name: 'Body Temperature',
        dis_name: 'Temperature',
        units_with_ranges: [
            {
                dis_unit: 'F',
                code: '258712004',
                code_id: 'vu-2329086300',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '97',
                    high: '99',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
            {
                dis_unit: 'C',
                code: '258710007',
                code_id: 'vu-2329026721',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '36.6',
                    high: '37.0',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-7561569471',
        snomed_id: '50373000',
        name: 'Body height',
        dis_name: 'Height',
        units_with_ranges: [
            {
                dis_unit: 'Cms',
                code: '258672001',
                code_id: 'vu-2305998272',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '0',
                    high: '250',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
            {
                dis_unit: 'Feet',
                code: '259051005',
                code_id: 'vu-3019850218',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '0',
                    high: '10',
                    type: 'string',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-7991006736',
        snomed_id: '27113001',
        name: 'Body weight',
        dis_name: 'Weight',
        units_with_ranges: [
            {
                dis_unit: 'Kgs',
                code: '258683005',
                code_id: 'vu-2306951588',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '0',
                    high: '300',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
            {
                dis_unit: 'Lbs',
                code: '258693003',
                code_id: 'vu-2307875107',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '0',
                    high: '500',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-3436660046',
        snomed_id: '364589006',
        name: 'Birth Weight',
        dis_name: 'Birth Weight',
        units_with_ranges: [
            {
                dis_unit: 'Kgs',
                code: '258683005',
                code_id: 'vu-2306951588',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '0',
                    high: '300',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
            {
                dis_unit: 'Lbs',
                code: '258693003',
                code_id: 'vu-2307875107',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '0',
                    high: '500',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-5305097546',
        snomed_id: '60621009',
        name: 'Body mass index',
        dis_name: 'BMI',
        units_with_ranges: [
            {
                dis_unit: 'kg/m2',
                code: '60621009',
                code_id: 'vu-9497159785',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '18.5',
                    high: '24.9',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-9242267093',
        name: 'Systolic blood pressure',
        snomed_id: '271649006',
        dis_name: 'Systolic BP',
        units_with_ranges: [
            {
                dis_unit: 'mmHg',
                code: '259018001',
                code_id: 'vu-3016364667',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '100',
                    high: '140',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-8296133834',
        name: 'Diastolic blood pressure',
        snomed_id: '271650006',
        dis_name: 'Diastolic BP',
        units_with_ranges: [
            {
                dis_unit: 'mmHg',
                code: '259018001',
                code_id: 'vu-3016364667',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '70',
                    high: '90',
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    {
        id: 'lb-7205446246',
        name: 'Occipital Frontal Circumference (OFC)',
        dis_name: 'Occipital Frontal Circumference (OFC)',
        units_with_ranges: [
            {
                dis_unit: 'cm',
                code_id: 'lu-32969',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-2756254774',
        snomed_id: '73964-9',
        name: 'Muscle Mass',
        dis_name: 'Muscle Mass',
        units_with_ranges: [
            {
                dis_unit: 'Kg',
                code_id: 'lu-33211',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '32.4',
                    high: '40.4',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-3518970078',
        snomed_id: '101685-6',
        name: 'Bone Mass',
        dis_name: 'Bone Mass',
        units_with_ranges: [
            {
                dis_unit: 'Kg',
                code_id: 'lu-33211',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '2.3',
                    high: '2.9',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-7651203718',
        snomed_id: '41982-0',
        name: 'Fat Mass',
        dis_name: 'Body Fat Mass (%)',
        units_with_ranges: [
            {
                dis_unit: '%',
                code_id: 'lu-998',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '14.6',
                    high: '25.2',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-4105992481',
        snomed_id: '',
        name: 'Metabolic Age (Years)',
        dis_name: 'Metabolic Age',
        units_with_ranges: [
            {
                dis_unit: 'a',
                code: '',
                code_id: 'lu-1058',
                system: '',
                safe: {
                    low: '0',
                    high: '120',
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    {
        id: 'lb-7881503220',
        snomed_id: '',
        name: 'RANDOM, GLUCOSE, PLASMA [Mass/Vol]',
        dis_name: 'Random Blood Sugar (RBS), Serum',
        units_with_ranges: [
            {
                dis_unit: 'mg/dl',
                code: '',
                code_id: 'lu-991284286',
                system: '',
                safe: {
                    low: '60',
                    high: '140',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-9927104553',
        snomed_id: '',
        name: 'GLYCOSYLATED HEMOGLOBIN [Mass fraction]',
        dis_name: 'HbA1c (Glycosylated Hemoglobin)',
        units_with_ranges: [
            {
                dis_unit: '%',
                code: '',
                code_id: 'lu-998',
                system: '',
                safe: {
                    low: '3.9',
                    high: '5.7',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-8944586484',
        snomed_id: '',
        name: 'Neonatal Infant Pain Scale (NIPS) Assessment',
        dis_name: 'NIPS Pain Scale',
        units_with_ranges: [
            {
                dis_unit: '.',
                code: '',
                code_id: 'local-v-100',
                system: '',
                safe: {
                    low: '0',
                    high: '7',
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    {
        id: 'lb-6747212395',
        snomed_id: '',
        name: 'Wong Baker Pain Scale',
        dis_name: 'Wong Baker Pain Scale',
        units_with_ranges: [
            {
                dis_unit: '.',
                code: '',
                code_id: 'local-v-100',
                system: '',
                safe: {
                    low: '0',
                    high: '10',
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    {
        id: 'lb-7531814732',
        snomed_id: '',
        name: 'FLACC Pain Severity Score',
        dis_name: 'FLACC Pain Severity Score',
        units_with_ranges: [
            {
                dis_unit: '.',
                code: '',
                code_id: 'local-v-100',
                system: '',
                safe: {
                    low: '0',
                    high: '10',
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    {
        id: 'lb-6256346048',
        snomed_id: '',
        name: 'Head Circumference',
        dis_name: 'HC - Head Circumference',
        units_with_ranges: [
            {
                dis_unit: '.cm',
                code: '',
                code_id: 'lu-32969',
                system: '',
                safe: {
                    low: 'Not Applicable',
                    high: 'Not Applicable',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-1755571500',
        snomed_id: '',
        name: 'Chest Circumference',
        dis_name: 'CC - Chest Circumference',
        units_with_ranges: [
            {
                dis_unit: '.cm',
                code: '',
                code_id: 'lu-32969',
                system: '',
                safe: {
                    low: 'Not Applicable',
                    high: 'Not Applicable',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-3357626736',
        snomed_id: '',
        name: 'Mid Arm Circumference',
        dis_name: 'Mid Arm Circumference',
        units_with_ranges: [
            {
                dis_unit: '.cm',
                code: '',
                code_id: 'lu-32969',
                system: '',
                safe: {
                    low: 'Not Applicable',
                    high: 'Not Applicable',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-8986646210',
        snomed_id: '',
        name: 'Waist Circumference',
        dis_name: 'WC- Waist Circumference',
        units_with_ranges: [
            {
                dis_unit: 'cm',
                code: '',
                code_id: 'lu-32969',
                system: '',
                safe: {
                    low: 'Not Applicable',
                    high: 'Not Applicable',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-8083140639',
        snomed_id: '',
        name: 'Abdominal Girth',
        dis_name: 'Abdominal Girth',
        units_with_ranges: [
            {
                dis_unit: 'cm',
                code: '',
                code_id: 'lu-32969',
                system: '',
                safe: {
                    low: 'Not Applicable',
                    high: 'Not Applicable',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-3253549862',
        snomed_id: '',
        name: 'Neck Circumference',
        dis_name: 'Neck Circumference',
        units_with_ranges: [
            {
                dis_unit: 'cm',
                code: '',
                code_id: 'lu-32969',
                system: '',
                safe: {
                    low: '',
                    high: '',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-4945013521',
        snomed_id: '',
        name: 'Last Menstrual Period  (LMP)',
        dis_name: 'Last Menstrual Period  (LMP)',
        units_with_ranges: [
            {
                dis_unit: ' ',
                code: '',
                code_id: 'lu-1129356246',
                system: '',
                safe: {
                    low: '',
                    high: '',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
];

export const VITALS_AS_DATE = ['lb-4945013521'];

export const CUSTOM_VITALS_SAFE_RANGE: { [k: string]: { [k: string]: Safe } } = {
    'lb-7651203718': {
        m: {
            low: '14.6',
            high: '25.2',
            type: 'Numeric',
            is_decimal_allowed: true,
        },
        f: {
            low: '17.5',
            high: '31.3',
            type: 'Numeric',
            is_decimal_allowed: true,
        },
    },
};

// Business Id => set of vital ids
/**
 *  @deprecated there should not be user specific hard coding
 */
export const VITALS_WITHOUT_RANGE: {
    [k: string]: Set<string>;
} = {
    '74117920305567': new Set(['lb-7561569471', 'lb-7991006736']),
};

export const changeVitalIdFromVToLB = (array?: VitalsEntity | VitalsSelectedItemsType[]) => {
    if (!Array.isArray(array)) {
        return [];
    }
    const arrayWithNewId = array.map((i) => ({
        ...i,
        id: OLD_HARDCODED_VITALS_TO_NEW_MAPPING_V_TO_LB[i.id] || i.id,
    }));
    return arrayWithNewId;
};

export const changeVitalIdFromVToLBInVitalsConfig = (vitalsConfig?: VitalsConfig): VitalsConfig => {
    if (!vitalsConfig) return { selectedItems: [] };
    vitalsConfig.selectedItems = changeVitalIdFromVToLB(vitalsConfig.selectedItems);
    return vitalsConfig;
};
